function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

import BasePlugin from '@uppy/core/lib/BasePlugin.js';
import * as tus from 'tus-js-client';
import { Provider, RequestClient, Socket } from '@uppy/companion-client';
import emitSocketProgress from '@uppy/utils/lib/emitSocketProgress';
import getSocketHost from '@uppy/utils/lib/getSocketHost';
import settle from '@uppy/utils/lib/settle';
import EventTracker from '@uppy/utils/lib/EventTracker';
import NetworkError from '@uppy/utils/lib/NetworkError';
import isNetworkError from '@uppy/utils/lib/isNetworkError';
import { RateLimitedQueue } from '@uppy/utils/lib/RateLimitedQueue';
import hasProperty from '@uppy/utils/lib/hasProperty';
import getFingerprint from './getFingerprint.js';
var packageJson = {
  "version": "3.0.4"
};
/** @typedef {import('..').TusOptions} TusOptions */

/** @typedef {import('tus-js-client').UploadOptions} RawTusOptions */

/** @typedef {import('@uppy/core').Uppy} Uppy */

/** @typedef {import('@uppy/core').UppyFile} UppyFile */

/** @typedef {import('@uppy/core').FailedUppyFile<{}>} FailedUppyFile */

/**
 * Extracted from https://github.com/tus/tus-js-client/blob/master/lib/upload.js#L13
 * excepted we removed 'fingerprint' key to avoid adding more dependencies
 *
 * @type {RawTusOptions}
 */

var tusDefaultOptions = {
  endpoint: '',
  uploadUrl: null,
  metadata: {},
  uploadSize: null,
  onProgress: null,
  onChunkComplete: null,
  onSuccess: null,
  onError: null,
  overridePatchMethod: false,
  headers: {},
  addRequestId: false,
  chunkSize: Infinity,
  retryDelays: [100, 1000, 3000, 5000],
  parallelUploads: 1,
  removeFingerprintOnSuccess: false,
  uploadLengthDeferred: false,
  uploadDataDuringCreation: false
};
/**
 * Tus resumable file uploader
 */

var _retryDelayIterator = /*#__PURE__*/_classPrivateFieldLooseKey("retryDelayIterator");

var _queueRequestSocketToken = /*#__PURE__*/_classPrivateFieldLooseKey("queueRequestSocketToken");

var _requestSocketToken = /*#__PURE__*/_classPrivateFieldLooseKey("requestSocketToken");

var Tus = /*#__PURE__*/function (_BasePlugin) {
  _inherits(Tus, _BasePlugin);

  var _super = _createSuper(Tus);

  /**
   * @param {Uppy} uppy
   * @param {TusOptions} opts
   */
  function Tus(uppy, _opts) {
    var _this4;

    _classCallCheck(this, Tus);

    var _this$opts$rateLimite, _this$opts$retryDelay;

    _this4 = _super.call(this, uppy, _opts);
    Object.defineProperty(_assertThisInitialized(_this4), _retryDelayIterator, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this4), _queueRequestSocketToken, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this4), _requestSocketToken, {
      writable: true,
      value: function () {
        var _value = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(file) {
          var Client, client, opts, res;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  Client = file.remote.providerOptions.provider ? Provider : RequestClient;
                  client = new Client(_this4.uppy, file.remote.providerOptions);
                  opts = _objectSpread({}, _this4.opts);

                  if (file.tus) {
                    // Install file-specific upload overrides.
                    Object.assign(opts, file.tus);
                  }

                  _context.next = 6;
                  return client.post(file.remote.url, _objectSpread(_objectSpread({}, file.remote.body), {}, {
                    endpoint: opts.endpoint,
                    uploadUrl: opts.uploadUrl,
                    protocol: 'tus',
                    size: file.data.size,
                    headers: opts.headers,
                    metadata: file.meta
                  }));

                case 6:
                  res = _context.sent;
                  return _context.abrupt("return", res.token);

                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function value(_x) {
          return _value.apply(this, arguments);
        }

        return value;
      }()
    });
    _this4.type = 'uploader';
    _this4.id = _this4.opts.id || 'Tus';
    _this4.title = 'Tus'; // set default options

    var defaultOptions = {
      useFastRemoteRetry: true,
      limit: 20,
      retryDelays: tusDefaultOptions.retryDelays,
      withCredentials: false
    }; // merge default options with the ones set by user

    /** @type {import("..").TusOptions} */

    _this4.opts = _objectSpread(_objectSpread({}, defaultOptions), _opts);

    if ((_opts == null ? void 0 : _opts.allowedMetaFields) === undefined && 'metaFields' in _this4.opts) {
      throw new Error('The `metaFields` option has been renamed to `allowedMetaFields`.');
    }

    if ('autoRetry' in _opts) {
      throw new Error('The `autoRetry` option was deprecated and has been removed.');
    }
    /**
     * Simultaneous upload limiting is shared across all uploads with this plugin.
     *
     * @type {RateLimitedQueue}
     */


    _this4.requests = (_this$opts$rateLimite = _this4.opts.rateLimitedQueue) != null ? _this$opts$rateLimite : new RateLimitedQueue(_this4.opts.limit);
    _classPrivateFieldLooseBase(_assertThisInitialized(_this4), _retryDelayIterator)[_retryDelayIterator] = (_this$opts$retryDelay = _this4.opts.retryDelays) == null ? void 0 : _this$opts$retryDelay.values();
    _this4.uploaders = Object.create(null);
    _this4.uploaderEvents = Object.create(null);
    _this4.uploaderSockets = Object.create(null);
    _this4.handleResetProgress = _this4.handleResetProgress.bind(_assertThisInitialized(_this4));
    _this4.handleUpload = _this4.handleUpload.bind(_assertThisInitialized(_this4));
    _classPrivateFieldLooseBase(_assertThisInitialized(_this4), _queueRequestSocketToken)[_queueRequestSocketToken] = _this4.requests.wrapPromiseFunction(_classPrivateFieldLooseBase(_assertThisInitialized(_this4), _requestSocketToken)[_requestSocketToken]);
    return _this4;
  }

  _createClass(Tus, [{
    key: "handleResetProgress",
    value: function handleResetProgress() {
      var files = _objectSpread({}, this.uppy.getState().files);

      Object.keys(files).forEach(function (fileID) {
        // Only clone the file object if it has a Tus `uploadUrl` attached.
        if (files[fileID].tus && files[fileID].tus.uploadUrl) {
          var tusState = _objectSpread({}, files[fileID].tus);

          delete tusState.uploadUrl;
          files[fileID] = _objectSpread(_objectSpread({}, files[fileID]), {}, {
            tus: tusState
          });
        }
      });
      this.uppy.setState({
        files: files
      });
    }
    /**
     * Clean up all references for a file's upload: the tus.Upload instance,
     * any events related to the file, and the Companion WebSocket connection.
     *
     * @param {string} fileID
     */

  }, {
    key: "resetUploaderReferences",
    value: function resetUploaderReferences(fileID, opts) {
      if (opts === void 0) {
        opts = {};
      }

      if (this.uploaders[fileID]) {
        var uploader = this.uploaders[fileID];
        uploader.abort();

        if (opts.abort) {
          uploader.abort(true);
        }

        this.uploaders[fileID] = null;
      }

      if (this.uploaderEvents[fileID]) {
        this.uploaderEvents[fileID].remove();
        this.uploaderEvents[fileID] = null;
      }

      if (this.uploaderSockets[fileID]) {
        this.uploaderSockets[fileID].close();
        this.uploaderSockets[fileID] = null;
      }
    }
    /**
     * Create a new Tus upload.
     *
     * A lot can happen during an upload, so this is quite hard to follow!
     * - First, the upload is started. If the file was already paused by the time the upload starts, nothing should happen.
     *   If the `limit` option is used, the upload must be queued onto the `this.requests` queue.
     *   When an upload starts, we store the tus.Upload instance, and an EventTracker instance that manages the event listeners
     *   for pausing, cancellation, removal, etc.
     * - While the upload is in progress, it may be paused or cancelled.
     *   Pausing aborts the underlying tus.Upload, and removes the upload from the `this.requests` queue. All other state is
     *   maintained.
     *   Cancelling removes the upload from the `this.requests` queue, and completely aborts the upload-- the `tus.Upload`
     *   instance is aborted and discarded, the EventTracker instance is destroyed (removing all listeners).
     *   Resuming the upload uses the `this.requests` queue as well, to prevent selectively pausing and resuming uploads from
     *   bypassing the limit.
     * - After completing an upload, the tus.Upload and EventTracker instances are cleaned up, and the upload is marked as done
     *   in the `this.requests` queue.
     * - When an upload completed with an error, the same happens as on successful completion, but the `upload()` promise is
     *   rejected.
     *
     * When working on this function, keep in mind:
     *  - When an upload is completed or cancelled for any reason, the tus.Upload and EventTracker instances need to be cleaned
     *    up using this.resetUploaderReferences().
     *  - When an upload is cancelled or paused, for any reason, it needs to be removed from the `this.requests` queue using
     *    `queuedRequest.abort()`.
     *  - When an upload is completed for any reason, including errors, it needs to be marked as such using
     *    `queuedRequest.done()`.
     *  - When an upload is started or resumed, it needs to go through the `this.requests` queue. The `queuedRequest` variable
     *    must be updated so the other uses of it are valid.
     *  - Before replacing the `queuedRequest` variable, the previous `queuedRequest` must be aborted, else it will keep taking
     *    up a spot in the queue.
     *
     * @param {UppyFile} file for use with upload
     * @returns {Promise<void>}
     */

  }, {
    key: "upload",
    value: function upload(file) {
      var _this5 = this;

      var _this = this;

      this.resetUploaderReferences(file.id); // Create a new tus upload

      return new Promise(function (resolve, reject) {
        var queuedRequest;
        var qRequest;
        var upload;

        _this5.uppy.emit('upload-started', file);

        var opts = _objectSpread(_objectSpread({}, _this5.opts), file.tus || {});

        if (typeof opts.headers === 'function') {
          opts.headers = opts.headers(file);
        }
        /** @type {RawTusOptions} */


        var uploadOptions = _objectSpread(_objectSpread({}, tusDefaultOptions), opts); // We override tus fingerprint to uppy’s `file.id`, since the `file.id`
        // now also includes `relativePath` for files added from folders.
        // This means you can add 2 identical files, if one is in folder a,
        // the other in folder b.


        uploadOptions.fingerprint = getFingerprint(file);

        uploadOptions.onBeforeRequest = function (req) {
          var xhr = req.getUnderlyingObject();
          xhr.withCredentials = !!opts.withCredentials;
          var userProvidedPromise;

          if (typeof opts.onBeforeRequest === 'function') {
            userProvidedPromise = opts.onBeforeRequest(req, file);
          }

          if (hasProperty(queuedRequest, 'shouldBeRequeued')) {
            if (!queuedRequest.shouldBeRequeued) return Promise.reject();
            var done;
            var p = new Promise(function (res) {
              // eslint-disable-line promise/param-names
              done = res;
            });
            queuedRequest = _this5.requests.run(function () {
              if (file.isPaused) {
                queuedRequest.abort();
              }

              done();
              return function () {};
            }); // If the request has been requeued because it was rate limited by the
            // remote server, we want to wait for `RateLimitedQueue` to dispatch
            // the re-try request.
            // Therefore we create a promise that the queue will resolve when
            // enough time has elapsed to expect not to be rate-limited again.
            // This means we can hold the Tus retry here with a `Promise.all`,
            // together with the returned value of the user provided
            // `onBeforeRequest` option callback (in case it returns a promise).

            return Promise.all([p, userProvidedPromise]);
          }

          return userProvidedPromise;
        };

        uploadOptions.onError = function (err) {
          var _queuedRequest;

          _this5.uppy.log(err);

          var xhr = err.originalRequest ? err.originalRequest.getUnderlyingObject() : null;

          if (isNetworkError(xhr)) {
            // eslint-disable-next-line no-param-reassign
            err = new NetworkError(err, xhr);
          }

          _this5.resetUploaderReferences(file.id);

          (_queuedRequest = queuedRequest) == null ? void 0 : _queuedRequest.abort();

          _this5.uppy.emit('upload-error', file, err);

          reject(err);
        };

        uploadOptions.onProgress = function (bytesUploaded, bytesTotal) {
          _this5.onReceiveUploadUrl(file, upload.url);

          _this5.uppy.emit('upload-progress', file, {
            uploader: _this5,
            bytesUploaded: bytesUploaded,
            bytesTotal: bytesTotal
          });
        };

        uploadOptions.onSuccess = function () {
          var uploadResp = {
            uploadURL: upload.url
          };

          _this5.resetUploaderReferences(file.id);

          queuedRequest.done();

          _this5.uppy.emit('upload-success', file, uploadResp);

          if (upload.url) {
            _this5.uppy.log("Download ".concat(upload.file.name, " from ").concat(upload.url));
          }

          resolve(upload);
        };

        var defaultOnShouldRetry = function defaultOnShouldRetry(err) {
          var _err$originalResponse;

          var status = err == null ? void 0 : (_err$originalResponse = err.originalResponse) == null ? void 0 : _err$originalResponse.getStatus();

          if (status === 429) {
            // HTTP 429 Too Many Requests => to avoid the whole download to fail, pause all requests.
            if (!_this5.requests.isPaused) {
              var _classPrivateFieldLoo;

              var next = (_classPrivateFieldLoo = _classPrivateFieldLooseBase(_this5, _retryDelayIterator)[_retryDelayIterator]) == null ? void 0 : _classPrivateFieldLoo.next();

              if (next == null || next.done) {
                return false;
              }

              _this5.requests.rateLimit(next.value);
            }
          } else if (status > 400 && status < 500 && status !== 409) {
            // HTTP 4xx, the server won't send anything, it's doesn't make sense to retry
            return false;
          } else if (typeof navigator !== 'undefined' && navigator.onLine === false) {
            // The navigator is offline, let's wait for it to come back online.
            if (!_this5.requests.isPaused) {
              _this5.requests.pause();

              window.addEventListener('online', function () {
                _this5.requests.resume();
              }, {
                once: true
              });
            }
          }

          queuedRequest.abort();
          queuedRequest = {
            shouldBeRequeued: true,
            abort: function abort() {
              this.shouldBeRequeued = false;
            },
            done: function done() {
              throw new Error('Cannot mark a queued request as done: this indicates a bug');
            },
            fn: function fn() {
              throw new Error('Cannot run a queued request: this indicates a bug');
            }
          };
          return true;
        };

        if (opts.onShouldRetry != null) {
          uploadOptions.onShouldRetry = function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            return opts.onShouldRetry.apply(opts, args.concat([defaultOnShouldRetry]));
          };
        } else {
          uploadOptions.onShouldRetry = defaultOnShouldRetry;
        }

        var copyProp = function copyProp(obj, srcProp, destProp) {
          if (hasProperty(obj, srcProp) && !hasProperty(obj, destProp)) {
            // eslint-disable-next-line no-param-reassign
            obj[destProp] = obj[srcProp];
          }
        };
        /** @type {Record<string, string>} */


        var meta = {};
        var allowedMetaFields = Array.isArray(opts.allowedMetaFields) ? opts.allowedMetaFields // Send along all fields by default.
        : Object.keys(file.meta);
        allowedMetaFields.forEach(function (item) {
          meta[item] = file.meta[item];
        }); // tusd uses metadata fields 'filetype' and 'filename'

        copyProp(meta, 'type', 'filetype');
        copyProp(meta, 'name', 'filename');
        uploadOptions.metadata = meta;
        upload = new tus.Upload(file.data, uploadOptions);
        _this5.uploaders[file.id] = upload;
        _this5.uploaderEvents[file.id] = new EventTracker(_this5.uppy); // eslint-disable-next-line prefer-const

        qRequest = function qRequest() {
          if (!file.isPaused) {
            upload.start();
          } // Don't do anything here, the caller will take care of cancelling the upload itself
          // using resetUploaderReferences(). This is because resetUploaderReferences() has to be
          // called when this request is still in the queue, and has not been started yet, too. At
          // that point this cancellation function is not going to be called.
          // Also, we need to remove the request from the queue _without_ destroying everything
          // related to this upload to handle pauses.


          return function () {};
        };

        upload.findPreviousUploads().then(function (previousUploads) {
          var previousUpload = previousUploads[0];

          if (previousUpload) {
            _this5.uppy.log("[Tus] Resuming upload of ".concat(file.id, " started at ").concat(previousUpload.creationTime));

            upload.resumeFromPreviousUpload(previousUpload);
          }
        });
        queuedRequest = _this5.requests.run(qRequest);

        _this5.onFileRemove(file.id, function (targetFileID) {
          queuedRequest.abort();

          _this5.resetUploaderReferences(file.id, {
            abort: !!upload.url
          });

          resolve("upload ".concat(targetFileID, " was removed"));
        });

        _this5.onPause(file.id, function (isPaused) {
          queuedRequest.abort();

          if (isPaused) {
            // Remove this file from the queue so another file can start in its place.
            upload.abort();
          } else {
            // Resuming an upload should be queued, else you could pause and then
            // resume a queued upload to make it skip the queue.
            queuedRequest = _this5.requests.run(qRequest);
          }
        });

        _this5.onPauseAll(file.id, function () {
          queuedRequest.abort();
          upload.abort();
        });

        _this5.onCancelAll(file.id, function (_temp) {
          var _ref = _temp === void 0 ? {} : _temp,
              reason = _ref.reason;

          if (reason === 'user') {
            queuedRequest.abort();

            _this.resetUploaderReferences(file.id, {
              abort: !!upload.url
            });
          }

          resolve("upload ".concat(file.id, " was canceled"));
        });

        _this5.onResumeAll(file.id, function () {
          queuedRequest.abort();

          if (file.error) {
            upload.abort();
          }

          queuedRequest = _this5.requests.run(qRequest);
        });
      })["catch"](function (err) {
        _this5.uppy.emit('upload-error', file, err);

        throw err;
      });
    }
    /**
     * @param {UppyFile} file for use with upload
     * @returns {Promise<void>}
     */

  }, {
    key: "uploadRemote",
    value: function () {
      var _uploadRemote = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(file) {
        var serverToken;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.resetUploaderReferences(file.id); // Don't double-emit upload-started for Golden Retriever-restored files that were already started

                if (!file.progress.uploadStarted || !file.isRestored) {
                  this.uppy.emit('upload-started', file);
                }

                _context2.prev = 2;

                if (!file.serverToken) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", this.connectToServerSocket(file));

              case 5:
                _context2.next = 7;
                return _classPrivateFieldLooseBase(this, _queueRequestSocketToken)[_queueRequestSocketToken](file);

              case 7:
                serverToken = _context2.sent;

                if (this.uppy.getState().files[file.id]) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt("return", undefined);

              case 10:
                this.uppy.setFileState(file.id, {
                  serverToken: serverToken
                });
                return _context2.abrupt("return", this.connectToServerSocket(this.uppy.getFile(file.id)));

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](2);
                this.uppy.emit('upload-error', file, _context2.t0);
                throw _context2.t0;

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 14]]);
      }));

      function uploadRemote(_x2) {
        return _uploadRemote.apply(this, arguments);
      }

      return uploadRemote;
    }()
    /**
     * See the comment on the upload() method.
     *
     * Additionally, when an upload is removed, completed, or cancelled, we need to close the WebSocket connection. This is
     * handled by the resetUploaderReferences() function, so the same guidelines apply as in upload().
     *
     * @param {UppyFile} file
     */

  }, {
    key: "connectToServerSocket",
    value: function connectToServerSocket(file) {
      var _this6 = this;

      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var token = file.serverToken;
        var host = getSocketHost(file.remote.companionUrl);
        var socket = new Socket({
          target: "".concat(host, "/api/").concat(token)
        });
        _this6.uploaderSockets[file.id] = socket;
        _this6.uploaderEvents[file.id] = new EventTracker(_this6.uppy);
        var queuedRequest;

        _this6.onFileRemove(file.id, function () {
          queuedRequest.abort();
          socket.send('cancel', {});

          _this6.resetUploaderReferences(file.id);

          resolve("upload ".concat(file.id, " was removed"));
        });

        _this6.onPause(file.id, function (isPaused) {
          if (isPaused) {
            // Remove this file from the queue so another file can start in its place.
            queuedRequest.abort();
            socket.send('pause', {});
          } else {
            // Resuming an upload should be queued, else you could pause and then
            // resume a queued upload to make it skip the queue.
            queuedRequest.abort();
            queuedRequest = _this6.requests.run(function () {
              socket.send('resume', {});
              return function () {};
            });
          }
        });

        _this6.onPauseAll(file.id, function () {
          queuedRequest.abort();
          socket.send('pause', {});
        });

        _this6.onCancelAll(file.id, function (_temp2) {
          var _ref2 = _temp2 === void 0 ? {} : _temp2,
              reason = _ref2.reason;

          if (reason === 'user') {
            queuedRequest.abort();
            socket.send('cancel', {});

            _this2.resetUploaderReferences(file.id);
          }

          resolve("upload ".concat(file.id, " was canceled"));
        });

        _this6.onResumeAll(file.id, function () {
          queuedRequest.abort();

          if (file.error) {
            socket.send('pause', {});
          }

          queuedRequest = _this6.requests.run(function () {
            socket.send('resume', {});
            return function () {};
          });
        });

        _this6.onRetry(file.id, function () {
          // Only do the retry if the upload is actually in progress;
          // else we could try to send these messages when the upload is still queued.
          // We may need a better check for this since the socket may also be closed
          // for other reasons, like network failures.
          if (socket.isOpen) {
            socket.send('pause', {});
            socket.send('resume', {});
          }
        });

        _this6.onRetryAll(file.id, function () {
          // See the comment in the onRetry() call
          if (socket.isOpen) {
            socket.send('pause', {});
            socket.send('resume', {});
          }
        });

        socket.on('progress', function (progressData) {
          return emitSocketProgress(_this6, progressData, file);
        });
        socket.on('error', function (errData) {
          var message = errData.error.message;
          var error = Object.assign(new Error(message), {
            cause: errData.error
          }); // If the remote retry optimisation should not be used,
          // close the socket—this will tell companion to clear state and delete the file.

          if (!_this6.opts.useFastRemoteRetry) {
            _this6.resetUploaderReferences(file.id); // Remove the serverToken so that a new one will be created for the retry.


            _this6.uppy.setFileState(file.id, {
              serverToken: null
            });
          } else {
            socket.close();
          }

          _this6.uppy.emit('upload-error', file, error);

          queuedRequest.done();
          reject(error);
        });
        socket.on('success', function (data) {
          var uploadResp = {
            uploadURL: data.url
          };

          _this6.uppy.emit('upload-success', file, uploadResp);

          _this6.resetUploaderReferences(file.id);

          queuedRequest.done();
          resolve();
        });
        queuedRequest = _this6.requests.run(function () {
          if (file.isPaused) {
            socket.send('pause', {});
          } // Don't do anything here, the caller will take care of cancelling the upload itself
          // using resetUploaderReferences(). This is because resetUploaderReferences() has to be
          // called when this request is still in the queue, and has not been started yet, too. At
          // that point this cancellation function is not going to be called.
          // Also, we need to remove the request from the queue _without_ destroying everything
          // related to this upload to handle pauses.


          return function () {};
        });
      });
    }
    /**
     * Store the uploadUrl on the file options, so that when Golden Retriever
     * restores state, we will continue uploading to the correct URL.
     *
     * @param {UppyFile} file
     * @param {string} uploadURL
     */

  }, {
    key: "onReceiveUploadUrl",
    value: function onReceiveUploadUrl(file, uploadURL) {
      var currentFile = this.uppy.getFile(file.id);
      if (!currentFile) return; // Only do the update if we didn't have an upload URL yet.

      if (!currentFile.tus || currentFile.tus.uploadUrl !== uploadURL) {
        this.uppy.log('[Tus] Storing upload url');
        this.uppy.setFileState(currentFile.id, {
          tus: _objectSpread(_objectSpread({}, currentFile.tus), {}, {
            uploadUrl: uploadURL
          })
        });
      }
    }
    /**
     * @param {string} fileID
     * @param {function(string): void} cb
     */

  }, {
    key: "onFileRemove",
    value: function onFileRemove(fileID, cb) {
      this.uploaderEvents[fileID].on('file-removed', function (file) {
        if (fileID === file.id) cb(file.id);
      });
    }
    /**
     * @param {string} fileID
     * @param {function(boolean): void} cb
     */

  }, {
    key: "onPause",
    value: function onPause(fileID, cb) {
      this.uploaderEvents[fileID].on('upload-pause', function (targetFileID, isPaused) {
        if (fileID === targetFileID) {
          // const isPaused = this.uppy.pauseResume(fileID)
          cb(isPaused);
        }
      });
    }
    /**
     * @param {string} fileID
     * @param {function(): void} cb
     */

  }, {
    key: "onRetry",
    value: function onRetry(fileID, cb) {
      this.uploaderEvents[fileID].on('upload-retry', function (targetFileID) {
        if (fileID === targetFileID) {
          cb();
        }
      });
    }
    /**
     * @param {string} fileID
     * @param {function(): void} cb
     */

  }, {
    key: "onRetryAll",
    value: function onRetryAll(fileID, cb) {
      var _this7 = this;

      this.uploaderEvents[fileID].on('retry-all', function () {
        if (!_this7.uppy.getFile(fileID)) return;
        cb();
      });
    }
    /**
     * @param {string} fileID
     * @param {function(): void} cb
     */

  }, {
    key: "onPauseAll",
    value: function onPauseAll(fileID, cb) {
      var _this8 = this;

      this.uploaderEvents[fileID].on('pause-all', function () {
        if (!_this8.uppy.getFile(fileID)) return;
        cb();
      });
    }
    /**
     * @param {string} fileID
     * @param {function(): void} eventHandler
     */

  }, {
    key: "onCancelAll",
    value: function onCancelAll(fileID, eventHandler) {
      var _this3 = this;

      this.uploaderEvents[fileID].on('cancel-all', function () {
        if (!_this3.uppy.getFile(fileID)) return;
        eventHandler.apply(void 0, arguments);
      });
    }
    /**
     * @param {string} fileID
     * @param {function(): void} cb
     */

  }, {
    key: "onResumeAll",
    value: function onResumeAll(fileID, cb) {
      var _this9 = this;

      this.uploaderEvents[fileID].on('resume-all', function () {
        if (!_this9.uppy.getFile(fileID)) return;
        cb();
      });
    }
    /**
     * @param {(UppyFile | FailedUppyFile)[]} files
     */

  }, {
    key: "uploadFiles",
    value: function uploadFiles(files) {
      var _this10 = this;

      var promises = files.map(function (file, i) {
        var current = i + 1;
        var total = files.length;

        if ('error' in file && file.error) {
          return Promise.reject(new Error(file.error));
        }

        if (file.isRemote) {
          // We emit upload-started here, so that it's also emitted for files
          // that have to wait due to the `limit` option.
          // Don't double-emit upload-started for Golden Retriever-restored files that were already started
          if (!file.progress.uploadStarted || !file.isRestored) {
            _this10.uppy.emit('upload-started', file);
          }

          return _this10.uploadRemote(file, current, total);
        } // Don't double-emit upload-started for Golden Retriever-restored files that were already started


        if (!file.progress.uploadStarted || !file.isRestored) {
          _this10.uppy.emit('upload-started', file);
        }

        return _this10.upload(file, current, total);
      });
      return settle(promises);
    }
    /**
     * @param {string[]} fileIDs
     */

  }, {
    key: "handleUpload",
    value: function handleUpload(fileIDs) {
      var _this11 = this;

      if (fileIDs.length === 0) {
        this.uppy.log('[Tus] No files to upload');
        return Promise.resolve();
      }

      if (this.opts.limit === 0) {
        this.uppy.log('[Tus] When uploading multiple files at once, consider setting the `limit` option (to `10` for example), to limit the number of concurrent uploads, which helps prevent memory and network issues: https://uppy.io/docs/tus/#limit-0', 'warning');
      }

      this.uppy.log('[Tus] Uploading...');
      var filesToUpload = fileIDs.map(function (fileID) {
        return _this11.uppy.getFile(fileID);
      });
      return this.uploadFiles(filesToUpload).then(function () {
        return null;
      });
    }
  }, {
    key: "install",
    value: function install() {
      this.uppy.setState({
        capabilities: _objectSpread(_objectSpread({}, this.uppy.getState().capabilities), {}, {
          resumableUploads: true
        })
      });
      this.uppy.addUploader(this.handleUpload);
      this.uppy.on('reset-progress', this.handleResetProgress);
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.uppy.setState({
        capabilities: _objectSpread(_objectSpread({}, this.uppy.getState().capabilities), {}, {
          resumableUploads: false
        })
      });
      this.uppy.removeUploader(this.handleUpload);
    }
  }]);

  return Tus;
}(BasePlugin);

export { Tus as default };
Tus.VERSION = packageJson.version;